<template>
  <div class="about">
     <div class="banner">
       <div class="title">用数智技术助力客户实现创意和梦想</div>
       <div class="info"> 以用户需求为导向，致力于为客户提供高品质的智能技术服务。</div>
     </div>
    <div class="model">
      <div class="model-text">
        <div class="title"><img src="../assets/images/about/icon.png"/>公司介绍</div>
        <div class="content">
          数创智能秉承“智能 + 工程”的核心理念，专业致力于工程结构（隧道、公路、桥梁、矿山等）安全检测监测技术、数据采集与分析平台、智慧运维技术的研发与应用，成为我国既有基础设施安全运营领域独具特色的系统化解决方案提供者。近年来，公司依托山东大学科研团队开展科技攻关，所研发的智能检测技术、自动化检测装备与智慧运维系统在国内多个地铁运营公司、公路维养部门、矿山企业进行了应用，为运营主体提供了智慧化运维的解决方法，赢得业主的一致赞誉。
        </div>
        <img src="../assets/images/about/link.png" class="link" alt="">
      </div>
    </div>
    <div class="model">
      <div class="model-text">
        <div class="title"><img src="../assets/images/about/icon1.png"/>公司定位</div>
        <div class="content">
          专注隧道、桥梁、道路、矿山等复杂场景的基建全生命周期安全管控，以AIoT（人工智能 + 物联网）技术为核心，融合智能机器人、高精度传感器、数字孪生与大数据分析，为客户提供 “ 技术 + 装备 + 系统 + 服务 ” 一体化检测监测解决方案，打造基础设施安全智能防御体系，护航工程结构可持续运行。
        </div>
      </div>
    </div>
    <div class="model" @click="openMap">

    </div>
    <footerView></footerView>
  </div>
</template>
<script>
import footerView from "@/components/footerView.vue";
export default {
  components:{
    footerView
  },
  data(){
    return {
      position:'https://map.baidu.com/poi/%E9%BD%90%E9%B2%81%E8%BD%AF%E4%BB%B6%E5%9B%AD%E5%88%9B%E4%B8%9A%E5%B9%BF%E5%9C%BA-D%E5%BA%A7/@13040160.174314182,4368522.1179471975,16.76z?uid=75036835c791e7d15f0d02a5&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl'
    }
  },
  mounted() {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  methods:{
    openMap(){
      window.open(this.position, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.about{
  background: #131415;
}
.banner{
  height: 540px;
  background: url(../assets/images/about/banner.png) no-repeat center top;
  background-size: auto 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  .title{
    font-size: 52px;
  }
  .info{
    font-size: 16px;
    text-align: center;
    width: 100%;
    line-height: 32px;
    margin-top: 16px;
  }
}
.model{
  min-height: 29.11vw;
  padding: 0 95px;
  display: flex;
  align-items: center;
  &:nth-child(2){
    background: url(../assets/images/about/about1.png) no-repeat center top;
    background-size:auto 100% ;
  }
  &:nth-child(3){
    background: url(../assets/images/about/about2.png) no-repeat center top;
    background-size: auto 100% ;
  }
  &:nth-child(4){
    background: url(../assets/images/about/map.png) no-repeat center top;
    background-size: auto 100% ;
    cursor: pointer;
  }
  .model-text{
    width: 40%;
    color: #fff;
    padding: 40px 0;
    .link{
      height: 49px;
      width: auto;
      margin-top: 30px;
      max-width: 100%;
    }
    .title{
      font-weight: 600;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 32px;
      letter-spacing: 1px;
      margin-bottom: 54px;
      display: flex;
      align-items: center;
      img{
        width: 32px;
        height: auto;
        margin-right: 4px;
        max-width: 100%;
      }
    }
    .content{
      font-weight: 400;
      font-size: 14px;
      line-height: 2;
      color: #FFFFFF;
      opacity: .6;
      margin-bottom: 30px;
      text-align: justify;
      
    }
  }
}

/* 大屏幕PC适配 */
@media screen and (min-width: 1600px) {
  .model {
    padding: 0 120px;
    .model-text {
      width: 48%;
      .title {
        font-size: 30px;
        margin-bottom: 60px;
      }
      .content {
        font-size: 18px;
        line-height: 2.2;
      }
    }
  }
}

/* 中屏幕PC适配 (1400-1599px) */
@media screen and (max-width: 1599px) and (min-width: 1400px) {
  .model {
    padding: 0 100px;
    .model-text {
      width: 45%;
    }
  }
}

/* 小屏幕PC适配 (1200-1399px) */
@media screen and (max-width: 1399px) and (min-width: 1200px) {
  .model {
    padding: 0 80px;
    .model-text {
      width: 42%;
      .title {
        font-size: 22px;
        margin-bottom: 45px;
      }
      .content {
        font-size: 14px;
      }
    }
  }
}

/* 大屏平板适配 (1025-1199px) */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  .model {
    padding: 0 60px;
    .model-text {
      width: 45%;
      .title {
        font-size: 20px;
        margin-bottom: 40px;
      }
    }
  }
}

/* 平板设备适配 (769-1024px) */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .banner .title{
    font-size: 42px;
  }
  .model {
    padding: 0 40px;
    .model-text {
      width: 56%;
      .title {
        font-size: 20px;
        margin-bottom: 35px;
      }
      .content {
        font-size: 13px;
        line-height: 1.8;
      }
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .model{
    align-items: flex-start;
    padding: 20px 16px;
    min-height: 64vw;
    .model-text{
      width: 100%;
      .title{
        font-size: 18px;
        img{
          width: 32px;
        }
      }
      .content{
        font-size: 14px;
        line-height: 24px;
      }
    }
    &:nth-child(2){
      background: url(../assets/images/about/icon1-m.png) no-repeat center top;
      background-size: auto 100% ;
    }
    &:nth-child(3){
      background: url(../assets/images/about/icon2-m.png) no-repeat center top;
      background-size: auto 100% ;
    }
    &:nth-child(4){
      background: url(../assets/images/about/map-m.png) no-repeat center top;
      background-size:  100%  auto;
      cursor: pointer;
    }
  }

  .banner {
    height: 48vw;
    background: url(../assets/images/about/banner-m.png) no-repeat;
    background-size: 100% auto;
    padding-top: 30px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      line-height: 30px;
    }

    .info {
      font-size: 12px;
    }
  }
}
</style>
